<div class="outer-container" [ngClass]="{'field-empty': label.length === 0}">
  <div class="label">
    <lib-text-common [infoTip]="infoTip">
      {{ label }}
    </lib-text-common>
  </div>
  @if (hasFontImage) {
    <div class="value-font-image">
      <i [class]="fontImage"></i>
    </div>
  } @else {
    @if (fontImage !== false) {
      <div class="value-no-font-image">
        <lib-text-common>
        </lib-text-common>
      </div>
    } @else {
      <div class="value-no-font-image">
        <ng-content></ng-content>
      </div>
    }
  }
</div>
